function Ajax() {
	this.init();
}

Ajax.prototype.init = function () {
	$('body').on('click', '.-content-module .pagination__ajax a', function(e){
		e.preventDefault();
		var link = $(this);
		var section = link.closest('.-content-module');
		var cm = link.closest('.pagination').attr('data-cm-id');
		var tags = [];
		var category = section.prev('section').find('.filter-category__dropdown a.-active').attr('href');
		if (category===undefined) category = link.closest('.pagination').attr('data-category');
		// link.toggleClass('-active');
		// link.parent().find('.-active').each(function(){
			// tags.push($(this).attr('data-url'));
		// });
		// link.parent().addClass('-loading');
		section.find('.listing-content').find('.loader').addClass('-visible');
		$.ajax({
			type: "POST",
			url: category+'?tags='+tags.join()+"&"+link.attr('href').replace(/\?/,'')+"&cm="+cm,
			success : function(data) {
				var $data = $(data);
				var content = $data.find('.news-index-listing').html();
				var staticPagination = $data.find('.filters-pagination').html();
				section.find('.filters-pagination').html(staticPagination);
				section.find('.pagination').remove();
				section.find('.news-index-listing').append(content);
				section.find('.listing-content').find('.loader').removeClass('-visible');
				app.waypoints = new Waypoints();
				app.images = new ResponsiveBackgroundImage();
			}
		});
	});

	$('body').on('click', '.news-filters-dropdown .dropdown-top-bar ul li a, .news-filters-dropdown .dropdown-content a', function(e){
		e.preventDefault();
		e.stopPropagation();
		var link = $(this);
		var section;
		if ($('.news-filters-dropdown').hasClass('-listing')) {
			section = link.closest('.news-filters-dropdown').siblings('.listing-content');
			section.find('.loader').addClass('-visible');
		} else {
			section = link.closest('.news-filters-dropdown').siblings('.home-news').find('.news-container');
			section.siblings('.loader').addClass('-visible');
		}
		$.ajax({
			type: "POST",
			url: link.attr('href'),
			success : function(data) {
				var $data = $(data);
				var content;
				if ($('.news-filters-dropdown').hasClass('-listing')) {
					content = $data.find('.listing-content').html();
				} else {
					content = $data.filter('.news-container').html();
				}
				link.closest('ul').find('a').removeClass('-active');
				link.siblings('a').removeClass('-active');
				link.addClass('-active');
				section.html(content);
				if ($('.news-filters-dropdown').hasClass('-listing')) {
					section.find('.loader').removeClass('-visible');
				} else {
					section.siblings('.loader').removeClass('-visible');
				}
				app.waypoints = new Waypoints();
				app.images = new ResponsiveBackgroundImage();
			}
		});
	});

	$('body').on('click', '.events-filters .dropdown-top-bar ul li a', function(e){
		e.preventDefault();
		var link = $(this);
		var section;
		if (link.closest('.events-filters').siblings('.events-index-slider').find('.events-carousel').length) {
			section = link.closest('.events-filters').siblings('.events-index-slider').find('.events-carousel');
			link.closest('.events-filters').siblings('.events-index-slider').find('.loader').addClass('-visible');
		} else {
			section = link.closest('.events-filters').siblings('.listing-content').find('.events-index-listing');
			link.closest('.events-filters').siblings('.listing-content').find('.loader').addClass('-visible');
		}
		$.ajax({
			type: "POST",
			url: link.attr('href'),
			success : function(data) {
				var $data = $(data);
				var content;
				if (link.closest('.events-filters').siblings('.events-index-slider').find('.events-carousel').length) {
					content = $data.filter('.events-carousel').html();
				} else {
					content = $data.find('.events-index-listing').html();
				}
				link.closest('ul').find('a').removeClass('-active');
				link.addClass('-active');
				section.html(content);
				if (link.closest('.events-filters').siblings('.events-index-slider').find('.events-carousel').length) {
					app.slick.createCarousel(section.closest('.events-index-slider').find('.events-carousel-slider'));
					link.closest('.events-filters').siblings('.events-index-slider').find('.loader').removeClass('-visible');
				} else {
					link.closest('.events-filters').siblings('.listing-content').find('.loader').removeClass('-visible');
				}
				app.waypoints = new Waypoints();
				app.images = new ResponsiveBackgroundImage();
			}
		});
	});

	// $('body').on('click', '.filter-tags__dropdown a', function(e){
	// 	e.preventDefault();
	// 	var link = $(this);
	// 	var parentSection = link.closest('.filter');
	// 	var section = parentSection.next('section');
	// 	var tags = [];
	// 	var category = parentSection.find('.filter-category__dropdown a.-active').attr('href');
	// 	var cm = parentSection.attr('data-cm-id');
	// 	if (category===undefined) category = parentSection.attr('data-category');
	// 	link.toggleClass('-active');
	// 	section.addClass('-hide');
	// 	link.parent().find('.-active').each(function(){
	// 		tags.push($(this).attr('data-url'));
	// 	});
	// 	$.ajax({
	// 		type: "POST",
	// 		url : category+'?tags='+tags.join()+"&cm="+cm,
	// 		success : function(data) {
	// 			section.empty().append(data).removeClass('-hide');
	// 			//$(document).foundation('equalizer', 'reflow');				
	// 			$(document).foundation('interchange', 'reflow');
	// 			$('.articles-index-wrapper').packery({
	// 				itemSelector: '.articles-index-item',
	// 				gutter: 0,
	// 				percentPosition: true
	// 			});
	// 		},
	// 		error : function() {
	// 			section.removeClass('-hide');
	// 		}
	// 	});
	// });

	// $('body').on('click', '.filter-category__dropdown a', function(e){
	// 	e.preventDefault();
	// 	var link = $(this);
	// 	var parentSection = link.closest('.filter');
	// 	var section = parentSection.next('section');
	// 	var accordion = parentSection.find('.filter-category__dropdown').data('accordion');
	// 	parentSection.find('.filter-category__dropdown a').removeClass('-active');
	// 	parentSection.find('.filter-tags__dropdown a').removeClass('-active');
	// 	parentSection.find('.filter-category__header a').text(link.text());
	// 	link.addClass('-active');
	// 	section.addClass('-hide');
	// 	accordion.collapse();
	// 	$.ajax({
	// 		type: "POST",
	// 		url : link.attr('href'),
	// 		success : function(data) {
	// 			section.empty().append(data).removeClass('-hide');
	// 			var tags = section.find('.category-tag-list').html();
	// 			parentSection.find('.tag-list').empty().append(tags);
	// 			// $(document).foundation('equalizer', 'reflow');
	// 		},
	// 		error : function() {
	// 			section.removeClass('-hide');
	// 		}
	// 	});
	// });

	$('body').on('click', '.articles-calendar-index-nav__months a', function(e){
		e.preventDefault();
		var link = $(this);
		var section = link.closest('.-content-module');
		var section_id = section.attr('data-section-id');
		section.addClass('-loading');
		$.ajax({
			type: "POST",
			url: link.attr('href'),
			success : function(data) {
				var $data = $('<div>'+data+'</div>');//.find('section[data-section-id="'+section_id+'"]');
				section.find('.articles-calendar-index-nav__months a:first-child').attr('href',$data.find('.articles-calendar-index-nav__months a:first-child').attr('href'));
				section.find('.articles-calendar-index-nav__months a:last-child').attr('href',$data.find('.articles-calendar-index-nav__months a:last-child').attr('href'));
				section.find('.articles-calendar-index-nav__months .month').empty().append($data.find('.articles-calendar-index-nav__months .month').text());
				section.find('.articles-calendar-index-nav__days').empty().append($data.find('.articles-calendar-index-nav__days').html());
				section.find('.articles-calendar-index-wrapper').empty().append($data.find('.articles-calendar-index-wrapper').html());
				section.find('.articles-calendar-index-group.-active .articles-calendar-index-items').each(function(){
			        app.slick.createCalendarSlider($(this));
			    });
			    $(document).foundation('interchange', 'reflow');
				setTimeout(function() {
					section.removeClass('-loading');
				}, 10);
			}
		});
	});
};